/**
 * Central labels and game counts for pass type ids (Firestore passConfigs doc ids).
 * Keep in sync with scripts/seed-pass-configs.js.
 */
export const PASS_TYPE_DISPLAY_NAMES = {
  '1-game': 'Single Game',
  '5-game': '5 Game Pass',
  '10-game': '10 Game Pass',
  '25-game': '25 Game Pass',
  'full-season': 'Full Season Pass',
  'spring26-1nw-8': 'Spring Pass – April & May · 1 night / week (8 skates)',
  'spring26-2nw-16': 'Spring Pass – April & May · 2 nights / week (16 skates)',
  'spring26-3nw-24': 'Spring Pass – April & May · 3 nights / week (24 skates)',
  'spring26-god-32': 'Spring Pass – April & May · God mode (32 skates)'
}

/** Games granted when an admin adds a pass manually (not full-season). */
export const PASS_TYPE_GAMES_TOTAL = {
  '1-game': 1,
  '5-game': 5,
  '10-game': 10,
  '25-game': 25,
  'full-season': 999,
  'spring26-1nw-8': 8,
  'spring26-2nw-16': 16,
  'spring26-3nw-24': 24,
  'spring26-god-32': 32
}

export function getPassTypeDisplayName (passType) {
  if (!passType) return 'Pass'
  return PASS_TYPE_DISPLAY_NAMES[passType] || passType
}

export function getPassGamesTotalForAdminGrant (passType) {
  if (passType === 'full-season') return 999
  const n = PASS_TYPE_GAMES_TOTAL[passType]
  if (n !== undefined) return n
  return 1
}
